"use client"
/* */
import { jsxs, jsx } from 'react/jsx-runtime';
import { createContext, useContext } from 'react';
import { NotificationController } from './NotificationController.mjs';
import { NotificationContainer } from './NotificationContainer/NotificationContainer.mjs';
import { viewComponentContext } from '../../lib/viewComponentContext/viewComponentContext.mjs';

const context = createContext(
  new NotificationController()
);
const useNotificationController = () => useContext(context);
const NotificationProvider = (props) => {
  const { children, ...containerProps } = props;
  const controller = NotificationController.useNew();
  const ContainerView = useContext(viewComponentContext)["NotificationContainer"] ?? NotificationContainer;
  return /* @__PURE__ */ jsxs(context.Provider, { value: controller, children: [
    /* @__PURE__ */ jsx(ContainerView, { ...containerProps }),
    children
  ] });
};

export { NotificationProvider, NotificationProvider as default, useNotificationController };
//# sourceMappingURL=NotificationProvider.mjs.map
